import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import CustomerGateway from '~apis/customer';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TGetCustomerCollateralReduxParams } from '~types/feat/customer';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetCustomerCollateralListing(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerGetCustomerCollateralListingAttempt', handleGetCustomerCollateralListing, api);
}

function* handleGetCustomerCollateralListing(api: CustomerGateway, data: PayloadAction<TGetCustomerCollateralReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const index = reduxState.customer.customerCollateral.index;
    const {
        customerId,
    } = data.payload;

    if (!index && index !== 0) {
        yield put(combinedActions.customerGetCustomerCollateralListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getCollateralListing], {
        authToken,
        index,
        customerId: customerId || undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerGetCustomerCollateralListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerGetCustomerCollateralListingSuccess(response.data));
    }
}
